const styles = (theme) => ({
    closeIconDiv: {
        display: 'flex',
        alignContent: 'flex-end',
        flexDirection: 'row-reverse'
    },
    closeIconButton: {
        padding: 5,
        position: 'absolute',
        marginLeft: -4,
        marginTop: 4,
        color: 'rgba(0, 0, 0, 0.84)'
    },
    closeIcon: {
        fontSize: 15
    }
});

export default styles;
